// Phone → wa.me helpers — Pass 53.
//
// Mirrors the backend's `whatsapp_digits()` (backend/server.py) exactly,
// so a rep's one-tap wa.me link in the leads list resolves to the same
// number the server already uses for review-request WhatsApp sends.
// Keep these two in sync if the normalization rule ever changes.

export function whatsappDigits(phone) {
  const digits = (phone || "").replace(/\D/g, "");
  if (!digits) return "";
  if (digits.startsWith("60")) return digits;
  // Strip a leading 0 (Malaysian local) and prepend the country code.
  const local = digits.startsWith("0") ? digits.slice(1) : digits;
  return `60${local}`;
}

// Returns "" when the phone doesn't resolve to any digits, so callers
// can fall back to plain text instead of rendering a dead link.
export function waLink(phone) {
  const digits = whatsappDigits(phone);
  return digits ? `https://wa.me/${digits}` : "";
}
